import React from "react";
import "./styles.scss";
export interface ICheckoutBanner {
  title?: string;
  subtitle?: string;
  icon?: string;
}

export const CheckoutBanner = (props: ICheckoutBanner) => {
  return (
    <div className="checkout-banner">
      <div className="checkout-banner-header">{props.title}</div>
      <div className="checkout-banner-subtitle">{props.subtitle}</div>
      {props.icon ? (
        <img className="checkout-banner-image" src={props.icon} alt="" />
      ) : null}
    </div>
  );
};
